import React from 'react';
import { Heart, Target, Shield, Lightbulb } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import './Values.css';

const Values = () => {
  const { t } = useLanguage();

  const values = [
    {
      icon: <Heart className="h-8 w-8" />,
      title: t('values.partnersFirst.title'),
      desc: t('values.partnersFirst.description')
    },
    {
      icon: <Target className="h-8 w-8" />,
      title: t('values.deliverBest.title'),
      desc: t('values.deliverBest.description')
    },
    {
      icon: <Shield className="h-8 w-8" />,
      title: t('values.integrity.title'),
      desc: t('values.integrity.description')
    },
    {
      icon: <Lightbulb className="h-8 w-8" />,
      title: t('values.entrepreneurial.title'),
      desc: t('values.entrepreneurial.description')
    }
  ];

  return (
    <section id="values" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('values.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('values.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {values.map((value, idx) => (
            <div
              key={idx}
              className="bg-white p-8 rounded-xl border-2 border-blue-200 hover:border-brand-primary transition-all shadow-lg hover:shadow-xl group"
            >
              <div className="flex items-start gap-4">
                <div className="bg-brand-primary text-white p-3 rounded-lg flex-shrink-0 group-hover:scale-110 transition-transform shadow-md">
                  {value.icon}
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{value.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
